import { Stack, Typography } from "@mui/material";
import { PageContext } from "./Pages";
import CustomGrid from "../../components/CustomGrid";
import useAsyncUpdate from "../../util/useAsyncUpdate";
import { getUserRowType, getUserType } from "../../schema/console/user";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import { GroupBase } from "../../schema/generated/Group";
import UserPage from "./user";
import StyledButton from "../../components/StyledButton";
import GroupPageLayout from "./GroupPage";
import { useYesNoDialog } from "../../components/dialog/YesNoDialog";
import { VoidAction } from "../../util/func";
import { useEffect } from "react";

export default function TopPageLayout({ pageContext }: { pageContext: PageContext }) {
  const api = pageContext.api;
  const [users, updateUsers] = useAsyncUpdate(api.user_data.get);
  const [groups, updateGroups] = useAsyncUpdate(api.group_data.get);

  useEffect(() => {
    updateUsers();
  }, [groups])

  if (!users || !groups) {
    return <>データをロード中です。</>;
  }

  return (
    <Routes>
      <Route index element={<TopPage pageContext={pageContext} users={users} groups={groups} update={updateGroups} />} />
      <Route path="user/*" element={<UserPage pageContext={pageContext} userData={users} groupData={groups} update={updateUsers} />} />
      <Route path="group/*" element={<GroupPageLayout pageContext={pageContext} groupData={groups} update={updateGroups} />} />
    </Routes>
  )
}

function TopPage({ pageContext, users, groups, update }: { pageContext: PageContext, users?: getUserRowType, groups?: GroupBase[], update: VoidAction }) {
  const api = pageContext.api;
  const navigate = useNavigate();
  const [deleteDialog, showDeleteDialog] = useYesNoDialog();

  const onUserDeleteClicked = (data: {id: string, name: string}) => {
    showDeleteDialog({
      title: "削除確認",
      text: `ユーザー名：${data.name} を削除してよろしいですか？`,
      onConfirm: () => api.user_data.delete({ id: data.id, deleted: true }).then(update),
    });
  }
  const onGroupDeleteClicked = (data: {id: string, name: string}) => {
    showDeleteDialog({
      title: "削除確認",
      text: `グループ名名：${data.name} を削除してよろしいですか？`,
      onConfirm: () => api.group_data.delete({ id: data.id, deleted: true }).then(update),
    });
  } 

  const userCols = [
    { field: "name", headerName: "ユーザー名", minWidth: 225, renderCell: (params: GridRenderCellParams<getUserType>) => (<Link to={`user/${params.row.id}/`}>{params.row.name}</Link>) },
    { field: "group_name", headerName: "所属", minWidth: 225, renderCell: (params: GridRenderCellParams<getUserType>) => (<Link to={`group/${params.row.group_id}/`}>{params.row.Group.name}</Link>) }
  ];

  const groupCols = [
    { field: "name", headerName: "グループ名", minWidth: 225, renderCell: (params: GridRenderCellParams<GroupBase>) => (<Link to={`group/${params.row.id}/`}>{params.row.name}</Link>) },
  ];

  return (
    <Stack width="100%" alignItems="center" pt="20px" gap={4} pb={8}>
      <Stack maxWidth={1200} width="80%" gap="26px">
        <Stack pt={4} gap="26px">
          <Typography fontSize={24} fontWeight="bold">ユーザー</Typography>
          { users ? <CustomGrid cols={userCols} rows={users.filter(r => r.deleted_at === null)} onActionClicked={onUserDeleteClicked} actionLabel="削除" /> : <>ユーザーがいません。</> }
          <StyledButton buttonStyle="secondary" onClick={() => {
            navigate("user/new/")
          }}>新規ユーザー作成</StyledButton>
        </Stack>
        <Stack pt={4} gap="26px">
          <Typography fontSize={24} fontWeight="bold">グループ</Typography>
          { groups ? <CustomGrid cols={groupCols} rows={groups.filter(r => r.deleted_at === null)} onActionClicked={onGroupDeleteClicked} actionLabel="削除" /> : <>グループがありません</> }
          <StyledButton buttonStyle="secondary" onClick={() => {
            navigate("group/new/")
          }}>新規グループ作成</StyledButton>
        </Stack>
      </Stack>
      {deleteDialog}
    </Stack>
  );
}
